import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { PortfolioItemProgressScoreChip } from 'user/components/PortfolioItemProgressScoreChip';
import { useGlobalDrawer } from 'common/hooks/useGlobalDrawer';
import {
    ICertificateWithScoringFragment,
    IPortfolioItemProgressFragment,
    useCurrentUserQuery,
} from 'graphql/types';
import { Link } from 'common/components/Link';
import { InfoRow } from 'common/components/InfoRow';
import { IGlobalDrawerType } from 'common/types';

interface IProps {
    certificate: ICertificateWithScoringFragment;
    certificatePortfolioItem?: IPortfolioItemProgressFragment | null;
}

export const CertificateInfoRow = ({
    certificate,
    certificatePortfolioItem,
}: IProps) => {
    const [translate] = useTranslation();
    const { openGlobalDrawer } = useGlobalDrawer();
    const { data: currentUserData } = useCurrentUserQuery();

    const currentUser = currentUserData?.currentUser;

    return (
        <InfoRow
            description={translate('certificate')}
            descriptionSx={{ mt: '3px' }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 1.25,
                }}
            >
                <PortfolioItemProgressScoreChip
                    portfolioItem={certificatePortfolioItem}
                    size="small"
                />

                <Link
                    sx={{ ml: 1, cursor: 'pointer' }}
                    onClick={() => {
                        if (!currentUser) return;

                        const { id, name } = certificate;

                        openGlobalDrawer({
                            type: IGlobalDrawerType.ReceivedCertificate,
                            itemId: id,
                            props: {
                                title: name,
                                user: currentUser,
                                certificateId: id,
                            },
                        });
                    }}
                >
                    {certificate.name}
                </Link>
            </Box>
        </InfoRow>
    );
};
